"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FONT_SIZE = 10;
exports.EmptyGraphicCollection = {
    graphics: {},
    dimensionOrder: [],
};
